import { render, staticRenderFns } from "./LunchTicketTable.vue?vue&type=template&id=17442dc2&"
import script from "./LunchTicketTable.vue?vue&type=script&lang=js&"
export * from "./LunchTicketTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports